import React, { useEffect } from 'react';
import styled from 'styled-components';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import ScrollableContainerWrapper from 'components/ScrollableContainerWrapper';
import HiddenFooterContainer from 'components/footer_v2/HiddenFooterContainer';
import GenericDesktopLobbyViewV2 from './GenericDesktopLobbyViewV2';
import GenericMobileLobbyView from './GenericMobileLobbyView';

const RootContainer = styled.div`
  height: 100%;
  overflow: hidden;
  background-color: #F0F1F2;
`;

const PageContentContainer = styled.div`
  min-width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
`;

const MainLobbyContainer = () => {
  useEffect(() => {
    window.trackingEventToFirebase(null, 'Main_Lobby', 'Enter', '');
  }, []);

  const isDesktop = useMediaQuery('(min-width: 1025px)');

  return (
    <RootContainer>
      <ScrollableContainerWrapper WrapperContainer={PageContentContainer}>
        {isDesktop ? <GenericDesktopLobbyViewV2 /> : <GenericMobileLobbyView />}
      </ScrollableContainerWrapper>
    </RootContainer>
  );
};

export default MainLobbyContainer;
